import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';
import Testimonials from './components/Testimonials';

declare const __VITE_SITE_URL__: string;
const siteUrl = typeof __VITE_SITE_URL__ !== 'undefined' ? __VITE_SITE_URL__ : 'https://kakobuy.click';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Kakobuy Spreadsheet Polska',
  url: siteUrl,
  description: 'Najlepszy Kakobuy Spreadsheet do zakupów z Chin. Poradniki zakupowe, porównania platform, listy produktów i bezpieczne zakupy z Chin.',
  inLanguage: 'pl-PL',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    availableLanguage: ['Polish', 'English'],
  },
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Kakobuy Spreadsheet Polska',
  url: siteUrl,
  description: 'Najlepszy Kakobuy Spreadsheet do zakupów z Chin. Poradniki, porównania i listy produktów.',
  inLanguage: 'pl-PL',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Kakobuy Spreadsheet Polska – Najlepszy Spreadsheet do Zakupów z Chin 2026',
  url: siteUrl,
  description: 'Odkryj najlepszy Kakobuy Spreadsheet 2026. Poradniki zakupowe, porównania platform, listy produktów i bezpieczne zakupy z Chin. Sprawdź nasz spreadsheet i znajdź najlepsze okazje!',
  inLanguage: 'pl-PL',
  isPartOf: {
    '@type': 'WebSite',
    name: 'Kakobuy Spreadsheet Polska',
    url: siteUrl,
  },
  about: {
    '@type': 'Thing',
    name: 'Kakobuy Spreadsheet',
    description: 'Kompleksowy arkusz kalkulacyjny z setkami sprawdzonych produktów do zakupów z chińskich platform.',
  },
};

export default function Home() {
  return (
    <main className="min-h-screen">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <ArticleSection />
      <CTASection />
      <Testimonials />
      <Footer />
    </main>
  );
}